module.exports = __webpack_public_path__ + "img/128.ffe735b8.jpg";